module.exports = __webpack_public_path__ + "img/lin-lin-plot.8567ad48.png";